import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import useAuth from '../../hooks/useAuth';

export const TigerySoftGuard = ({ children, roles }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (!user || user?.startScreen === undefined) {
        navigate('/auth/signin', { replace: true });
      } else if(user?.startScreen){
        //startScreen
        navigate('/auth/start-info', { replace: true });
      }else if (!roles?.includes(user.role)) {
        await Swal.fire({
          title: 'Acceso Denegado',
          text: 'No posee permiso para esta página',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Regresar',
        });

        navigate('/');
      } else {
        // User is authorized
        setLoading(false);
      }
    };

    checkAccess();
  }, [user, navigate, roles]);

  // Render nothing while loading
  if (loading) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
};